import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import FormField from './FormField';
import QuickUpdatableComponent from './QuickUpdatableComponent';
import { getDateTimeUTC } from './../../helpers/utils';

class DateInput extends QuickUpdatableComponent {
  render() {
    const { required, field, help, label, loading, disabled, time } = this.props;
    let value;
    if (field.value === '' || field.value === 'Invalid date' || field.value == 'Invalid Date') {
        value = '';
    } else if (_.isString(field.value)) {
        value = getDateTimeUTC(field.value, this.props.loggedIn && this.props.loggedIn['Timezone'], true).toDate();
        if (isNaN(value)) {
          value = '';
        }
    } else {
        value = field.value || '';
    }

    const showTime = time === undefined ? false : time;
    let format = 'MM/dd/yyyy'; // different rules than process.env.DATE_FORMAT;
    if (showTime) {
      format += ' HH:mm';
    }

    return (
        <FormField required={required} field={field} help={help} loading={loading} label={label}>
            <DatePicker {...field}
                        value={value}
                        onBlur={() => {}}
                        timeFormat="HH:mm"
                        dateFormat={format}
                        showTimeSelect={showTime}
                        selected={value}
                        disabled={disabled}
                        id={field.name}
                        todayButton="Today"
                        showMonthDropdown
                        showYearDropdown
            />
        </FormField>
    );
  }
}

const mapStateToProps = (state) => {
    return { loggedIn: state.user.loggedIn };
};

DateInput.propTypes = {
  field: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(DateInput);